export default __webpack_public_path__ + "img/ePziLdmF.3da5bff7.svg";